import { Box, Drawer, Stack } from "@hiver/hiver-ui-kit";
import React, { useReducer } from "react";
import { showMessage } from "../../../actions";
import { OPERATOR_KEYS } from "../../../constants/conversationFilter";
import { useConversationFiltersData } from "../../../hooks/useConversationFiltersData";
import { filterReducer, filterReducerInititalState } from "../reducer";
import {
  resetFilters,
  setTagsOperator,
  setWithoutTagsOperator,
} from "../reducer/actionCreators";
import { generateSmCoversationsPayload, getTagsOperatorsState } from "../utils";
import FilterMultiSelectContainer from "./FilterMultiSelectContainer";
import FilterPanelFooter from "./FilterPanelFooter";
import FilterPanelHeader from "./FilterPanelHeader";
import { sendTrackingEvent } from "../../../helpers";

export const ConversationFilterPanel = ({
  open,
  onClose,
  onApply,
  gainsightProps = {},
}) => {
  const [filtersState, filterDispatch] = useReducer(
    filterReducer,
    filterReducerInititalState
  );
  const filtersData = useConversationFiltersData();

  const onResetFilters = () => filterDispatch(resetFilters());

  const handleTagsOperationCases = () => {
    const {
      isAnyAllCombinationOperationSelected,
      tagsOperator,
      withoutTagsOperator,
    } = getTagsOperatorsState({ filtersState });

    // Any - All , All - All combination of tags filters is not allowed due api timeout restrictions,
    // If any-all / all-all combination is selected we change all operation to any and show a snackbar for the change.
    if (!isAnyAllCombinationOperationSelected) return;

    if (tagsOperator === OPERATOR_KEYS.ALL) {
      filterDispatch(setTagsOperator({ operator: OPERATOR_KEYS.ANY }));
      showMessage({
        message: `Showing all conversations that include 'Any selected tags' from the 'Tags: Contain' filter`,
      });
    }
    if (withoutTagsOperator === OPERATOR_KEYS.ALL) {
      filterDispatch(setWithoutTagsOperator({ operator: OPERATOR_KEYS.ANY }));
      showMessage({
        message: `Showing all conversations that include 'Any selected tags' from the 'Tags: Do not Contain' filter`,
      });
    }
  };
  const onApplyClicked = () => {
    handleTagsOperationCases();
    const filterPayload = generateSmCoversationsPayload({
      filtersState,
    });
    onApply(filterPayload);
    sendTrackingEvent("AI_CF_Test_page_filtered", { ...gainsightProps });
    onClose();
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="temporary"
      ModalProps={{
        hideBackdrop: true,
        keepMounted: true,
        sx: {
          pointerEvents: "none",
        },
      }}
      PaperProps={{
        sx: {
          width: 320,
          boxShadow: 3,
          pointerEvents: "auto",
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <FilterPanelHeader onClose={onClose} onReset={onResetFilters} />
        <Stack sx={{ gap: 4 }}>
          {filtersData.map((filterData, idx) => {
            return (
              <FilterMultiSelectContainer
                key={filterData.filterKey + idx}
                filtersState={filtersState}
                filterDispatch={filterDispatch}
                {...filterData}
              />
            );
          })}
        </Stack>
        <FilterPanelFooter onApply={onApplyClicked} onCancel={onClose} />
      </Box>
    </Drawer>
  );
};
